<template>
    <v-dialog v-model="dialog" max-width="500px">
        <loader v-if="isloading"></loader>
        <v-card shaped class="">
            <v-card-title
                class="text-h5 aviso"
                style="
                    justify-content: center;
                    background: #1d2735;
                    color: white;
                    margin-bottom: 1rem;
                "
            >
                Generar Obra
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-autocomplete
                            v-model="producto.id_elemento"
                            :items="productos"
                            item-text="codnombre"
                            item-value="id"
                            label="Producto"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea
                            v-model="producto.descripcion"
                            label="Descripción"
                        ></v-textarea>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <v-btn
                            color="red"
                            class="white--text"
                            @click="dialog = false"
                        >
                            Cancelar
                        </v-btn>

                        <v-btn
                            @click="saveorden"
                            :disabled="isloading"
                            color="success"
                            class="white--text"
                            >Guardar</v-btn
                        >
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import ordenesSelect from "../../../components/general/ordenesSelect.vue";
export default {
    props: ["id_cliente", "value"],
    components: {
        ordenesSelect,
    },
    data() {
        return {
            dialog: false,
            required_val: [
                (v) => !!v || "El campo es requerido",
                (v) => v != "" || "El campo es requerido",
            ],
            tab: 0,
            producto: {
                id_orden: null,
                id_producto: null,
                id_elemento: null,
                precio: 0,
                descripcion: null,
            },

            headers_fichaje: [
                {
                    text: "Usuario",
                    value: "usuario",
                    sortable: false,
                },
                {
                    text: "Tiempo",
                    value: "tiempo",
                    sortable: false,
                },
            ],
            headers: [
                {
                    text: "Producto",
                    value: "producto.titulo",
                    sortable: false,
                },
                {
                    text: "Descripción",
                    value: "descripcion",
                    sortable: false,
                },
            ],
            Ordenes: [],
            menu: false,
            productos: [],
            orden: {
                id: null,
                email: "",
                telefono: "",
                direccion: "",
            },
            presupuestos: [],
            tipos: [],
            estados: [],
            index_producto: 0,
        };
    },
    watch: {
        dialog(val) {
            this.$emit("input", val);
        },
        value(val) {
            this.dialog = val;
        },
        menu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
        },
    },
    created() {
        if (this.value != null) {
            this.dialog = this.value;
        }
        this.getProductos();
        this.getPresupuestos();
        this.getEstados();
    },
    mounted() {
        if (this.value != null) {
            this.dialog = this.value;
        }
    },
    methods: {
        deleteProducto(index) {
            this.orden.productos.splice(index, 1);
        },
        getProducto(index) {
            this.index_producto = index;
            this.producto = JSON.parse(
                JSON.stringify(this.orden.productos[index])
            );
        },
        updateProducto() {
            const producto = this.productos.find(
                (element) => element.id == this.producto.id_elemento
            );
            this.producto.producto = producto;
            this.orden.productos[this.index_producto] = this.producto;
            this.index_producto = 0;
            this.producto = {
                id_orden: null,
                id_producto: null,
                id_elemento: null,
                precio: 0,
                descripcion: null,
            };
        },
        navigate() {
            let lat = this.orden.cliente.latitud;
            let lng = this.orden.cliente.longitud;
            if (lat == null) {
                lat = this.orden.cliente.direccion.lat;
                lng = this.orden.cliente.direccion.lon;
            }
            // If it's an iPhone..
            if (
                navigator.platform.indexOf("iPhone") !== -1 ||
                navigator.platform.indexOf("iPod") !== -1
            ) {
                function iOSversion() {
                    if (/iP(hone|od|ad)/.test(navigator.platform)) {
                        // supports iOS 2.0 and later
                        var v = navigator.appVersion.match(
                            /OS (\d+)_(\d+)_?(\d+)?/
                        );
                        return [
                            parseInt(v[1], 10),
                            parseInt(v[2], 10),
                            parseInt(v[3] || 0, 10),
                        ];
                    }
                }
                var ver = iOSversion() || [0];

                var protocol = "http://";
                if (ver[0] >= 6) {
                    protocol = "maps://";
                }
                window.location =
                    protocol +
                    "maps.apple.com/maps?daddr=" +
                    lat +
                    "," +
                    lng +
                    "&amp;ll=";
            } else {
                window.open(
                    "http://maps.google.com?daddr=" +
                        lat +
                        "," +
                        lng +
                        "&amp;ll="
                );
            }
        },

        Fichar(detener) {
            axios
                .post(`api/fichar-orden/${this.$route.query.id}`, {
                    detener: false,
                })
                .then(
                    (res) => {
                        this.orden.fichajes = res.data.ordenes;
                        this.orden.fichajes_count = res.data.length;
                        this.orden.horas_realizadas = res.data.horas;
                        this.orden.id_estado = res.data.estado;
                        this.orden.horas_usuarios = res.data.horas_usuarios;
                    },
                    (res) => {}
                );
        },
        getProductos() {
            axios.get(`api/get-productos`).then(
                (res) => {
                    this.productos = res.data.Productos;
                },
                (res) => {}
            );
        },
        getEstados() {
            axios.get(`api/get-estados-orden`).then(
                (res) => {
                    this.estados = res.data;
                },
                (err) => {
                    this.$custom_error("Error consultando los estados");
                }
            );
        },
        getTipos() {
            axios.get(`api/get-tipos-orden`).then(
                (res) => {
                    this.tipos = res.data;
                },
                (err) => {
                    this.$custom_error("Error consultando los tipos");
                }
            );
        },
        getPresupuestos() {
            axios.get(`api/get-presupuestos?validacion=${0}`).then(
                (res) => {
                    this.presupuestos = res.data.Presupuestos;
                },
                (err) => {
                    this.$custom_error("Error consultando los presupuestos");
                }
            );
        },
        getorden(orden_id) {
            axios.get(`api/get-orden/${orden_id}`).then(
                (res) => {
                    this.orden = res.data;
                },
                (res) => {}
            );
        },
        updateorden() {
            axios
                .post("api/save-orden", this.orden)
                .then((res) => {
                    this.$router.push("lista-ordenes");
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        deleteArchivo(archivo) {
            axios.get(`api/delete-archivo-orden/${archivo.id}`).then(
                (res) => {
                    this.orden.archivo = res.data;
                },
                (res) => {
                    this.$toast.error("Error al eliminar el archivo");
                }
            );
        },
        subirArchivo(archivo) {
            archivo.append("id", this.orden.id);
            axios.post(`api/save-archivo-orden`, archivo).then((res) => {
                this.orden.archivo = res.data;
            });
        },
        saveorden() {
            this.orden.id_cliente = this.id_cliente;
            this.orden.productos = [this.producto];
            this.orden.id_estado = 1;
            this.orden.prioridad = 3;
            this.orden.id_tipo = 1;

            axios
                .post("api/save-orden", this.orden)
                .then((res) => {
                    this.dialog = false;
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        deleteorden() {
            axios.post("api/delete-orden", { id: this.orden.id }).then(
                (res) => {
                    this.dialog = false;
                },
                (res) => {}
            );
        },
        save(date) {
            this.$refs.menu.save(date);
        },
    },
    filters: {},
    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        roles() {
            return this.$store.getters.getroles;
        },
        rol: function () {
            return localStorage.getItem("role");
        },
        readonlyinput: function () {
            const rol = this.rol;
            return !(rol != 6 && rol != 7);
        },
    },
};
</script>
